import { useCallback, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { Event } from "models";
import { useDispatch } from "react-redux";
import { actions } from "redux-store";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonAdd: {
      position: "absolute",
      top: "initial",
      left: "initial",
      bottom: 48,
      right: 20,
    },
    eventPaperPhonePreviewRoot: {
      display: "relative",
      borderRadius: 10,
      overflow: "hidden",
      padding: 0,
    },
    bannerPreview: {
      objectFit: "cover",
      width: "100%",
      maxHeight: 106.6,
      borderBottom: "1px solid black",
    },
    eventPaperBottomContent: {
      padding: "1% 1% 1% 3%",
      position: "relative",
    },

    titlePreview: {
      fontWeight: "bold",
      fontSize: 16,
    },
    contentPreview: {
      overflow: "hidden",
      fontSize: 12,
    },
    textPreviewDivider: {
      alignSelf: "center",
      borderRadius: "2px",
      margin: "5px 0 10px 0",
    },
    timingInfo: {
      fontWeight: "bold",
      fontSize: 10,
      marginBottom: "1em",
    },
    editButton: {
      width: 37,
      height: 37,
      position: "absolute",
      top: 96,
      right: 31,
    },
  }),
);

const useEventPreview = (event: Event) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      paper: {
        root: styles.eventPaperPhonePreviewRoot,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();
  const dispatch = useDispatch();
  const [t] = useTypedTranslations();

  const setEventEditImageChanger = useCallback(() => {
    dispatch(actions.setEditEventDialogToImage(true));
  }, [dispatch]);

  const timeExpire = useMemo(
    () => ({
      hours: event.expiringMinutes
        ? parseInt(
            Number((Number(event.expiringMinutes) % 1440) / 60).toString(),
          )
        : 0,
      days: event.expiringMinutes
        ? parseInt(Number(Number(event.expiringMinutes) / 1440).toString())
        : 0,
      minutes: event.expiringMinutes
        ? parseInt(Number(Number(event.expiringMinutes) % 60).toString())
        : 0,
    }),
    [event],
  );

  return {
    styles,
    classes,
    atomicStyles,
    timeExpire,
    setEventEditImageChanger,
    t,
  };
};

export { useEventPreview as default };
